import FormatListBulletedOutlinedIcon from "@mui/icons-material/FormatListBulletedOutlined";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import LinkIcon from "@mui/icons-material/Link";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import Typography from "@mui/material/Typography";
import { shallowEqual, useSelector } from "react-redux";
import { RootState } from "../../redux";
import { UserInfo } from "../../ui/models/userInfo";
import "./index.scss";

export default function DashboardPage() {
  const authInfo = useSelector<RootState, UserInfo>(
    ({ auth }: any) => auth.info,
    shallowEqual
  );

  return (
    <div className="index-container">
      <div className="dashboard-layout">
        {/* ── Columna principal: Novedades ── */}
        <div className="novedades">
          {authInfo.role !== "ADMINWEB" && (
            <div className="novedad-container">
              <div className="title">
                <HandshakeOutlinedIcon />
                <Typography
                  variant="h6"
                  style={{ color: "#2563eb", fontWeight: 700 }}
                >
                  ¡Novedad! Visualización de Convenios
                </Typography>
              </div>

              <Typography
                variant="body1"
                style={{ color: "#334155", marginBottom: 0 }}
              >
                Ahora podés visualizar los Convenios vigentes de las Obras
                Sociales.
                <br />
                En el menú encontrarás un nuevo ítem llamado "Convenios".
              </Typography>
            </div>
          )}
          {authInfo.role === "PROFESIONAL" ||
            (authInfo.role === "PROFESIONALWEB" && (
              <div className="novedad-container">
                <div className="title">
                  <ManageAccountsOutlinedIcon />
                  <Typography
                    variant="h6"
                    style={{ color: "#7c3aed", fontWeight: 700 }}
                  >
                    ¿Mantenés tu perfil actualizado?
                  </Typography>
                </div>
                <Typography
                  variant="body1"
                  style={{ color: "#334155", marginBottom: 0 }}
                >
                  Recordá completar y mantener actualizados tus datos
                  profesionales: domicilio laboral, áreas de atención,
                  población, obras sociales y redes sociales.
                  <br />
                  Tus datos son visibles para el público en el directorio de
                  profesionales del portal. Accedé desde el menú{" "}
                  <strong>Mi Perfil</strong>.
                </Typography>
              </div>
            ))}
          {authInfo.role === "ADMIN" && (
            <div className="novedad-container">
              <div className="title">
                <FormatListBulletedOutlinedIcon />
                <Typography
                  variant="h6"
                  style={{ color: "#059669", fontWeight: 700 }}
                >
                  Listado de Precarga
                </Typography>
              </div>
              <Typography
                variant="body1"
                style={{ color: "#334155", marginBottom: 0 }}
              >
                Ahora, desde el menú "SEMPRE" podrás acceder al listado de
                Precarga.
                <br />
                Para visualizar resultados es necesario aplicar algún filtro
                para la búsqueda.
              </Typography>
            </div>
          )}
        </div>

        {/* ── Panel lateral: Links de Interés ── */}
        {authInfo.role !== "ADMINWEB" && (
          <aside className="links-interes">
            <div className="links-interes__header">
              <LinkIcon />
              <span>Autoriza +</span>
            </div>
            <div className="links-interes__list">
              {[
                {
                  label: "Sancor Salud",
                  url: "https://sancorsalud.com.ar/",
                  color: "#06b6d4",
                },
                {
                  label: "Prevención Salud",
                  url: "https://www.prevencionsalud.com.ar/",
                  color: "#10b981",
                },
                {
                  label: "Galeno - Federada Salud",
                  url: "https://menu.traditum.com/View/Login.aspx",
                  color: "#8b5cf6",
                },
                {
                  label: "Swiss Medical",
                  url: "https://www.swissmedical.com.ar/prestadores/",
                  color: "#f59e0b",
                },
                {
                  label: "Medicus",
                  url: "https://prestadores.medicus.com.ar/",
                  color: "#f43f5e",
                },
                {
                  label: "Nobis Salud",
                  url: "https://gecros.nobissalud.com.ar/login",
                  color: "#6366f1",
                },
              ].map(({ label, url, color }) => (
                <a
                  key={url}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="links-interes__link"
                  style={{ "--link-color": color } as React.CSSProperties}
                >
                  <span className="links-interes__link-dot" />
                  <span className="links-interes__link-label">{label}</span>
                  <OpenInNewIcon
                    className="links-interes__link-icon"
                    fontSize="small"
                  />
                </a>
              ))}
            </div>
          </aside>
        )}
      </div>
    </div>
  );
}
